// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"73ed07eb0dcde88c01c6","293":"83ca933e968518cdf8fd","518":"b52a8c4ea389b0ec6944","779":"c39afa09f3b0da3477b0"}[chunkId] + ".js";
};